module.exports = __webpack_public_path__ + "static/ball-c9425e1a0df41bbbac81a263b9f24e79.svg";